import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { responsables, responsablesEditar } from "../models/responsables"
import AccionesResponsables from "../components/accionesResponsables";
import { EstadoRegistro } from "../../../../utils/enums";


interface IProps {
    control: any;
    setResponsablesEditar: React.Dispatch<React.SetStateAction<responsablesEditar | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useColumns({ control, setResponsablesEditar, setModalDetalle }: IProps) {
    
    const COLUMNS: columns<responsables>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesResponsables
                    responsables={row}
                    control={control}
                    setResponsablesEditar={setResponsablesEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'RUT',
            selector: (row) =>
                format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre',
            selector: (row) =>
                `${row.nombres} ${row.apellidoPaterno} ${row.apellidoMaterno}`,
            sortable: true,
            sortField: 'nombres',
            wrap: true,
            export: true
        },
        {
            name: 'Email',
            selector: (row) =>
                row.email,
            sortable: true,
            sortField: 'email',
            wrap: true,
            export: true
        },
        {
            name: 'Responsabilidad',
            selector: (row) =>
                row.responsabilidad,
            sortable: true,
            sortField: 'responsabilidad',
            wrap: true,
            export: true
        },
        {
            name: 'Activo',
            selector: (row) =>
                row.estadoDescripcion,
            sortable: true,
            sortField: 'estadoDescripcion',
            wrap: true,
            export: true,
        },
    ]


    return { COLUMNS };
}